import { useNavigate } from 'react-router-dom';

// Clicking anywhere in a row / card opens the detail; links, buttons and inputs inside keep their own behaviour.
export function useRowOpen() {
  const navigate = useNavigate();
  return (id) => (e) => {
    if (e.target.closest('a, button, input, label, select')) return;
    navigate(`/zasilky/${Number(id)}`);
  };
}
